import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { Gauge, gaugeClasses } from '@mui/x-charts';
import InfoTooltipIcon from '@/components/icons/InfoTooltipIcon';
import { formatNumber } from '@/utils/formatters';

const KpiCard = ({ number, title, description, children, unit }) => {
  return (
    <Card
      variant="outlined"
      sx={{ p: 1, borderRadius: 2, minHeight: 240, height: '100%' }}
    >
      <CardContent sx={{ height: '100%' }}>
        <Stack
          direction="column"
          color="inherit"
          component={Card}
          elevation={0}
          sx={{
            transition: 'box-shadow 0.3s ease',
            height: '100%',
            background: 'transparent',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  fontWeight="bold"
                >
                  {title}
                </Typography>
                <InfoTooltipIcon title={description} />
              </Box>
            </Box>
          </Box>
          <Gauge
            width={200}
            height={130}
            value={number}
            cornerRadius={'40%'}
            startAngle={-110}
            endAngle={110}
            text={`${formatNumber(number)}${unit}`}
            sx={(theme) => ({
              [`& .${gaugeClasses.valueText}`]: {
                fontSize: 40,
              },
              [`& .${gaugeClasses.valueArc}`]: {
                fill: '#52b202',
                opacity: 0.8,
              },
              [`& .${gaugeClasses.referenceArc}`]: {
                fill: theme.palette.text.disabled,
                opacity: 0.5,
              },
              margin: '0 auto',
            })}
          />
          {children && (
            <Box
              sx={{
                mt: 2,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {children}
            </Box>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default KpiCard;
